import React from 'react';
import { CheckCircle2, ShieldCheck, Zap, ArrowRight, Lock } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/8Aw9jLDp6JjxgjUoVSorDX/98930e38-5ebb-403e-a4c3-f1e5763261a4.png';
export function Pricing() {
  return <section id="compra" className="py-14 md:py-24 bg-gradient-to-b from-emerald-50 via-white to-emerald-50/40 relative" data-id="element-215">
      {/* Tricolor top */}
      <div className="absolute top-0 left-0 w-full h-1.5 flex" data-id="element-216">
        <div className="flex-1 bg-[#008C45]" data-id="element-217" />
        <div className="flex-1 bg-white" data-id="element-218" />
        <div className="flex-1 bg-[#CD212A]" data-id="element-219" />
      </div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-220">
        <div className="text-center mb-8 md:mb-10" data-id="element-221">
          <p className="text-xs md:text-sm font-bold tracking-widest text-red-600 uppercase mb-2" data-id="element-222">
            OFERTA DE LANZAMIENTO
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-slate-900 mb-2" data-id="element-223">
            ITALIANO PRO KIT
          </h2>
          <p className="text-base md:text-xl text-slate-600 font-medium" data-id="element-224">
            PLAN PRO — Sistema completo + todos los bonos
          </p>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl border-2 border-emerald-500 overflow-hidden" data-id="element-225">
          {/* Tricolor strip */}
          <div className="h-1.5 flex" data-id="element-226">
            <div className="flex-1 bg-[#008C45]" data-id="element-227" />
            <div className="flex-1 bg-white" data-id="element-228" />
            <div className="flex-1 bg-[#CD212A]" data-id="element-229" />
          </div>

          <div className="grid md:grid-cols-2 gap-0" data-id="element-230">
            {/* Product image */}
            <div className="bg-gradient-to-br from-slate-900 to-emerald-950 p-6 md:p-10 flex items-center justify-center" data-id="element-231">
              <img src={PRODUCT_IMG} alt="Italiano Pro Kit" className="w-full max-w-xs h-auto drop-shadow-2xl" data-id="element-232" />
            </div>

            {/* Pricing details */}
            <div className="p-6 md:p-10" data-id="element-233">
              <div className="text-center md:text-left mb-6 md:mb-8" data-id="element-234">
                <div className="flex items-center justify-center md:justify-start gap-3 mb-1" data-id="element-235">
                  <span className="text-xl md:text-2xl text-slate-400 line-through font-bold" data-id="element-236">
                    $49.990
                  </span>
                  <span className="bg-red-100 text-red-600 text-[10px] md:text-xs font-bold px-2 py-1 rounded-full" data-id="element-237">
                    -60% OFF
                  </span>
                </div>
                <div className="text-5xl md:text-6xl font-extrabold text-slate-900 mb-3" data-id="element-238">
                  $19.990
                  <span className="text-lg md:text-xl text-slate-500 font-medium" data-id="element-239">
                    {' '}
                    ARS
                  </span>
                </div>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 md:gap-4 text-slate-600 font-medium text-xs md:text-sm" data-id="element-240">
                  <span className="flex items-center gap-1" data-id="element-241">
                    <ShieldCheck className="w-4 h-4 text-emerald-500" data-id="element-242" /> Pago
                    único
                  </span>
                  <span className="flex items-center gap-1" data-id="element-243">
                    <Zap className="w-4 h-4 text-emerald-500" data-id="element-244" /> Acceso de por
                    vida
                  </span>
                </div>
              </div>

              <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8" data-id="element-245">
                {['Acceso a todos los módulos', 'Los 3 bonus incluidos', 'Sistema completo listo para usar', 'Acceso de por vida', 'Actualizaciones incluidas'].map((item, idx) => <li key={idx} className="flex items-center gap-2 md:gap-3" data-id="element-246">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-500 flex-shrink-0" data-id="element-247" />
                    <span className="text-slate-700 font-medium text-sm md:text-base" data-id="element-248">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <a href="https://checkout.infodigitalcore.shop/cart/49563007615215:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-lg md:text-xl font-bold py-4 md:py-5 px-6 rounded-xl md:rounded-2xl shadow-xl shadow-emerald-500/30 transition-all hover:scale-[1.02] mb-3 flex items-center justify-center gap-2" data-id="element-249">
                COMPRAR AHORA
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-250" />
              </a>
              <p className="text-xs md:text-sm text-slate-500 font-medium flex items-center justify-center gap-2" data-id="element-251">
                <Lock className="w-3.5 h-3.5 text-emerald-500" data-id="element-252" /> Acceso
                inmediato luego del pago
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}